import React from 'react'
import { observer } from 'mobx-react-lite'
import { noteTakerStore } from 'shared/stores/noteTakerStore'
import s from '../NoteTakerDrawer.module.scss'

const DiscardSummaryModal = observer(() => {
	if (!noteTakerStore.isDiscardSummaryPromptOpen) return null

	return (
		<div className={s.discardModalOverlay} role="presentation">
			<div className={s.discardModal} role="dialog" aria-modal="true">
				<h3>Discard unsaved changes?</h3>
				<p>Your summary edits have not been saved.</p>
				<div className={s.editBar}>
					<button
						type="button"
						className={s.secondaryButton}
						onClick={() => noteTakerStore.cancelDiscardSummaryPrompt()}
					>
						Keep editing
					</button>
					<button
						type="button"
						className={s.dangerButton}
						onClick={() => noteTakerStore.confirmDiscardSummaryAndClose()}
					>
						Discard
					</button>
				</div>
			</div>
		</div>
	)
})

export default DiscardSummaryModal
